<template>
    <div></div>
</template>
<script>
export default {
  mounted () {
    this.$store.dispatch('account/logout').then(() => {
      // return location.reload()
      return this.$router.push('login')
    }).catch(() => {
      return location.reload()
      // return this.$router.push('login')
    })
  }
}
</script>